﻿import { ajaxGet } from '../utils/ajax';

if (!String.format) {
    String.format = function(format) {
        var args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] !== 'undefined'
              ? args[number]
              : match
            ;
        });
    };
}

export default {
    getProducts(blockid, address, callback, errorCallback) {
        if (blockid && address && Object.keys(address).length) {
            //Encode parameters to support IE9
            const url = String.format('/teliadk/accessofferingblock/availableproducts?blockid={0}&streetName={1}&streetNumber={2}&floorNumber={3}&floorSide={4}&postCode={5}',
                blockid,
                encodeURIComponent(address.streetName),
                encodeURIComponent(address.streetNumber) || '',
                encodeURIComponent(address.floorNumber) || '',
                encodeURIComponent(address.floorSide),
                address.postCode);


            setTimeout(function() {
                ajaxGet(url)
                    .then((json) => {
                        if (!json) {
                            errorCallback();
                            return;
                        }
                        const data = JSON.parse(json);
                        const products = data.products.map((p) => {
                            return {
                                installationFeeCode: p.installationFeeCode,
                                activationFeeCode: p.activationFeeCode,
                                paymentFeeCode: p.paymentFeeCode,
                                code: p.code,
                                blockId: p.blockId,
                                productDescription: p.productDescription,
                                uniqueSellingPointsMinus : p.uniqueSellingPointsMinus,
                                uniqueSellingPointsPlus : p.uniqueSellingPointsPlus,
                                variants: p.variants.map((v) => {
                                    return {
                                        code: v.code,
                                        actualSpeedText : v.actualSpeedText,
                                        uniqueSellingPointsMinus : v.uniqueSellingPointsMinus,
                                        uniqueSellingPointsPlus : v.uniqueSellingPointsPlus, 
                                        description: v.description,
                                        speedDown: v.downstreamSpeed || '',
                                        speedUp: v.upstreamSpeed || '',
                                        monetarySpeedUnit: v.monetarySpeedUnit,
                                        monthlyPrice: v.monthlyPrice,
                                        priceMonthly: v.priceMonthly,
                                        upfrontPrice: v.upfrontPrice,
                                        priceUpFront: v.priceUpFront,
                                        feePrice: v.feePrice,
                                        numberOfVas: v.numberOfVas,
                                        isRecommended: v.isRecommended,
                                        isTeliaHomeFree: v.isTeliaHomeFree,
                                        minimumPriceForBindingPeriod: v.minimumPriceForBindingPeriod,
                                        vendor: v.vendor
                                    }
                                })
                            };
                        });

                        callback(products);
                    })
                    .catch(errorCallback);
            }, 100);
        }
    }
}
